import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Hightlighter from 'react-highlight-words';
import { CustomInput, Loader, ErrorComponent } from 'components';
import { DeleteIcon } from 'assets/icons';
import { useFloating, flip, offset, autoUpdate } from '@floating-ui/react-dom';
import * as S from './ChooseCategory.styled';

import { useFacade } from './useFacade';

const ChooseCategory = ({ category, setValue, onChange, error, errorText }) => {
  const {
    isOpen,
    setIsOpen,
    handleClick,
    foundedCategories,
    handlePrint,
    isSuccess,
    isError,
    changeFocus,
  } = useFacade(onChange, category, setValue);

  const { refs, floatingStyles, update } = useFloating({
    middleware: [flip(), offset(5)],
    placement: 'top',
    whileElementsMounted: (reference, floating, update) =>
      autoUpdate(reference, floating, update, {
        ancestorResize: false,
        elementResize: false,
      }),
  });

  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) update();
  }, [isOpen, foundedCategories?.length, category]);

  const blurCategoryInput = () => {
    const input = document.querySelector('input[name="category"]');
    input?.blur();
  };

  return (
    <>
      {isOpen && !!foundedCategories?.length && <S.Slice onClick={() => setIsOpen(false)} />}
      <S.InputContainer onClick={() => setIsOpen(!isOpen)} ref={refs.setReference}>
        <S.InputHeader ref={inputRef}>
          <CustomInput
            onBlur={changeFocus}
            value={category}
            id='category'
            name='category'
            rightIcon={category?.length ? <DeleteIcon /> : null}
            rightIconOnClick={() => setValue('category', '', { shouldDirty: true })}
            onChange={handlePrint}
            isDropdown
            arrowIconIsActive={isOpen}
            error={error}
            errorText={errorText}
            autoComplete='off'
          />
        </S.InputHeader>
      </S.InputContainer>
      {isOpen && !!foundedCategories?.length && (
        <S.ComponentForScroll
          isOpen={isOpen}
          ref={refs.setFloating}
          style={{
            minWidth: inputRef.current.offsetWidth,
            ...floatingStyles,
          }}
        >
          <S.DropDownList>
            {isError && <ErrorComponent />}
            {!isSuccess && !isError && (
              <S.LoaderWrapp>
                <Loader.Global delay={1} />
              </S.LoaderWrapp>
            )}
            {isSuccess &&
              !isError &&
              foundedCategories?.map((cat) => (
                <S.ListItem
                  key={cat.application_type_id}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleClick(cat.application_type_name, blurCategoryInput);
                  }}
                >
                  <S.RadioBtn isActive={cat.application_type_name === category} />
                  <Hightlighter
                    textToHighlight={cat.application_type_name}
                    searchWords={[category]}
                    highlightTag='strong'
                  />
                </S.ListItem>
              ))}
          </S.DropDownList>
        </S.ComponentForScroll>
      )}
    </>
  );
};

export default ChooseCategory;

ChooseCategory.propTypes = {
  category: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  errorText: PropTypes.string,
};
